/* UpdateBanner — a quiet corner notice, never a modal (13-08). */

.banner {
  position: fixed;
  left: 20px;
  bottom: 20px;
  z-index: var(--z-toast);
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: calc(100vw - 40px);
  padding: 8px 8px 8px 16px;
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: var(--radius-full);
  box-shadow: var(--shadow-md);
  font-size: 13.5px;
  color: var(--charcoal);
  animation: hap-rise 0.32s var(--ease) both;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--teal);
  opacity: 0.75;
  flex: none;
}

.text {
  margin: 0;
}

.reload,
.later {
  border: none;
  border-radius: var(--radius-full);
  font-size: 13px;
  font-weight: 600;
  height: 30px;
  padding: 0 13px;
  white-space: nowrap;
  transition: background var(--transition-fast), color var(--transition-fast);
}

.reload {
  background: var(--teal);
  color: var(--white);
}

.reload:hover {
  background: var(--teal-dark);
}

.later {
  background: none;
  color: var(--gray);
}

.later:hover {
  background: var(--lavender-light);
  color: var(--purple-dark);
}
